import { createReducer } from '@reduxjs/toolkit';
import {
  removeCartItem,
  removeCartItemMessage,
  setAllCartItemData,
  setCartItemAmount,
  setCartItemMessage as setCartItemMessageAction,
} from './action';
import type { CartItemState } from './state';
import initialCartItemState from './state';
import isNumeric from '../../../../js/util/isNumeric';

const setCartItemMessage = (
  state: CartItemState,
  cartItemId: string,
  message: string,
) => {
  const item = state.items[cartItemId];

  if (!item) {
    return state;
  }
  return {
    ...state,
    items: {
      ...state.items,
      [cartItemId]: {
        ...item,
        giftCard: {
          ...item.giftCard,
          message,
        },
      },
    },
  };
};

const cartItemReducer = createReducer<CartItemState>(
  initialCartItemState,
  (builder) => {
    builder.addCase(removeCartItem, (state, { payload: { id } }) => {
      const { ...items } = state.items;
      delete items[id];

      const cartContainsAlcohol = !!Object.values(items).find(
        (item) => item.isAlcohol,
      );
      const cartContainsStrongAlcohol = !!Object.values(items).find(
        (item) => item.isStrongAlcohol,
      );

      return {
        ...state,
        cartContainsAlcohol,
        cartContainsStrongAlcohol,
        items,
      };
    });

    builder.addCase(
      setCartItemMessageAction,
      (state, { payload: { id, message } }) =>
        setCartItemMessage(state, id, message),
    );
    builder.addCase(removeCartItemMessage, (state, { payload: { id } }) =>
      setCartItemMessage(state, id, ''),
    );
    builder.addCase(
      setAllCartItemData,
      (
        state,
        { payload: { cartContainsAlcohol, cartContainsStrongAlcohol, items } },
      ) => ({
        ...state,
        cartContainsAlcohol,
        cartContainsStrongAlcohol,
        items,
      }),
    );

    builder.addCase(setCartItemAmount, (state, { payload: { amount, id } }) => {
      const oldItem = state.items[id];
      if (!oldItem) {
        return state;
      }
      const newAmount = isNumeric(amount)
        ? parseInt(amount, 10)
        : oldItem.amount;
      return {
        ...state,
        items: {
          ...state.items,
          [id]: {
            ...oldItem,
            amount: Math.max(1, newAmount),
            displayAmount: amount,
          },
        },
      };
    });
  },
);

export default cartItemReducer;
